




































import { Vue, Prop, Component, Emit, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import Thumbnail from '@/components/queuemanagement/status/thumbnail/Thumbnail.vue';
import Button from '@/components/utils/Button.vue';
import Select from '@/components/utils/Select.vue';
import PageFooter from '@/components/utils/PageFooter.vue';
import Popup from '@/components/queuemanagement/popup/Popup.vue';

@Component({
  components: {
    Thumbnail,
    Button,
    Select,
    PageFooter,
    Popup,
  },
})
export default class QueueStatus extends Vue {
  maxItemByPage: number = 8;

  currentPageIndex: number = 0;

  isShow: boolean = false;

  details: any = {};

  activeFilter: string = 'all';

  popupItemId: number = -1;

  selectedValue: any = {
    month: null,
    year: null,
  };

  yearForced: string = '';

  yearValue: string = '';

  formLength: Number = 0;

  dateMonth: any = {
    Janvier: 'January',
    Février: 'February',
    Mars: 'March',
    Avril: 'April',
    Mai: 'May',
    Juin: 'June',
    Juillet: 'July',
    Août: 'August',
    Septembre: 'September',
    Octobre: 'October',
    Novembre: 'November',
    Décembre: 'December',
  };

  async mounted() {
    await this.$store.dispatch('branche/a_init_Branches');
    await this.$store.dispatch('form/a_init_Form');
  }

  get compMonth(): Array<String> {
    return ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
  }

  get compYear(): Array<Number> {
    const year = new Date(Date.now()).getFullYear();
    const startingYear = 1970;
    return [...Array(year - (startingYear - 1)).keys()].map((v: number) => v + startingYear).sort((a, b) => b - a);
  }

  get compItem(): Array<any> {
    const branches = this.$store.getters['branche/list'] || [];
    const forms = this.$store.getters['form/list'] || [];
    if (forms.length) {
      return forms
        .map((form: any) => ({ ...form, branch: branches.find((branch: any) => branch.id === form.id_antenne) }))
        .sort((firstForm: any, secondForm: any) => {
          const firstFormCreatedDate = new Date(firstForm.created_at).getTime();
          const secondFormCreatedDate = new Date(secondForm.created_at).getTime();
          return secondFormCreatedDate - firstFormCreatedDate;
        });
    }
    return [];
  }

  get compPageItem(): Array<any> {
    console.log(this.compItem, this.compItem.length);
    return this.compItem.filter(this.filterFunction).slice(this.currentPageIndex * this.maxItemByPage, this.maxItemByPage * (this.currentPageIndex + 1));
  }

  get compCountPage(): number {
    if (this.$store.getters['form/list']) {
      return Math.ceil(this.$store.getters['form/list'].filter(this.filterFunction).length / this.maxItemByPage);
    }
    return 1;
  }

  @Watch('compItem')
  watchCompItem(): void {
    if (this.isShow) {
      this.updatePopupDetails(this.compItem.find((item: any) => item.id === this.popupItemId));
    }
  }

  updatePopupDetails(item: any): void {
    this.details = {
      id: item.id,
      queueName: item.adresse_ecole,
      branchName: this.compBranch(item),
      queueManager: this.compName(item),
      phone: item.telephone_usager,
      email: item.mail_usager,
      schoolAddress: item.adresse_ecole,
      schoolZip: item.zip_code_ecole,
      schoolCity: item.nom_ville_ecole,
      status: item.status,
      requestDate: item.created_at,
    };
  }

  filterFunction(item: any): boolean {
    if (this.activeFilter === 'all') {
      return true;
    }
    return item.status === this.activeFilter;
  }

  filterBy(status: string): void {
    this.activeFilter = status;
    this.currentPageIndex = 0;
  }

  leftArrowClicked(): void {
    if (this.currentPageIndex !== 0) {
      this.currentPageIndex -= 1;
    }
  }

  rightArrowClicked(): void {
    if (this.currentPageIndex !== this.compCountPage - 1) {
      this.currentPageIndex += 1;
    }
  }

  pageNumberclicked(page: number): void {
    this.currentPageIndex = page - 1;
  }

  compBranch(item: any): string {
    return `${item.nom_ville_ecole} (${item.zip_code_ecole.substring(0, 2)})`;
  }

  compName(item: any): string {
    return `${item.prenom_usager} ${item.nom_usager}`;
  }

  showPopup(item: any, index: number): void {
    this.isShow = true;
    this.popupItemId = item.id;
    this.updatePopupDetails(item);
  }

  closePopup(): void {
    this.isShow = false;
  }

  updateSelected(val: any, info: string) {
    if (info === 'month') {
      if (this.yearValue === '' && val !== '') {
        console.log('Forced year');
        this.yearForced = new Date(Date.now()).getFullYear().toString();
      }
      this.selectedValue.month = val ? this.dateMonth[val] : null;
    }
    if (info === 'year') {
      this.yearValue = val;
      this.selectedValue.year = val || null;
    }
  }

  async changeFormFilter(val: any, info: string) {
    console.log(val, info);
    this.updateSelected(val, info);

    await this.changeFilter(this.selectedValue, { dispatch: 'form/a_get_listSorted' }, { dispatch: 'form/a_get_list' });
    this.currentPageIndex = 0;
  }

  async changeFilter(selectedValue: any, routeFilter: any, routeNoFilter: any): Promise<any> {
    if (selectedValue.month !== null || selectedValue.year !== null) {
      await this.$store.dispatch(routeFilter.dispatch, { month: selectedValue.month, year: selectedValue.year });
    } else {
      await this.$store.dispatch(routeNoFilter.dispatch);
    }
  }
}
